<template>
  <a-modal
    v-model="visible"
    :title="$t('user_btn_change_password')"
    :maskClosable="false"
    :closable="!formLoading"
    :okText="$t('com_btn_save')"
    :width="700"
    @ok="formSubmit"
    @cancel="formReset"
    :confirmLoading="formLoading"
    :cancelButtonProps="{
      props: {
        disabled: formLoading,
      },
    }"
    destroyOnClose
    centered
  >
    <a-form-model
      :model="form"
      :rules="formRules"
      ref="formElement"
      :label-col="{ span: 7 }"
      :wrapper-col="{ span: 14 }"
      v-if="userInfo"
    >
      <!-- 用户名称 -->
      <a-form-model-item :label="$t('user_table_userName')">
        <div style="color:#f00;">{{ userInfo.name }}</div>
      </a-form-model-item>

      <!-- 密码 -->
      <a-form-model-item
        has-feedback
        :label="$t('user_form_password')"
        prop="password"
        style="margin-bottom:0"
      >
        <a-input-password
          v-model="form.password"
          :placeholder="$t('user_form_password_placeholder')"
          autocomplete="off"
        />
      </a-form-model-item>
      <a-form-model-item label=" " :colon="false" style="margin-bottom:0;">
        <div class="help" style="color:#999;line-height:20px;">
          {{ $t('com_form_password_help') }}
        </div>
      </a-form-model-item>
    </a-form-model>
    <!-- 错误描述 -->
    <div class="form-error-text">
      <Icon type="error" v-if="formError" />
      <p>{{ formError }}</p>
    </div>
  </a-modal>
</template>
<script>
import * as API from '@/api/system/user';
import areaMixin from '@/mixins/area';
import { checkPassword } from '@/libs/validator';

export default {
  mixins: [areaMixin],
  props: {
    callback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      userInfo: null,
      // 新增
      visible: false,
      loading: true,
      formRules: {
        password: [
          {
            required: true,
            message: this.$t('user_form_password_placeholder'),
          },
          {
            validator: this.validatePassword,
          },
        ],
      },

      // 搜索
      form: {
        password: undefined,
      },

      formError: '',
      formLoading: false,
    };
  },
  methods: {
    // 显示
    show(userInfo) {
      this.visible = true;
      this.userInfo = userInfo;
    },

    // 验证密码
    validatePassword(rule, value, callback) {
      if (!value) {
        callback();
      }
      if (!checkPassword(value)) {
        callback('Invalid password!');
        return;
      }
      callback();
    },

    // 提交
    formSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          this.formLoading = true;
          const params = { ...this.form };
          params.userId = this.userInfo.userId;
          API.UserChangePassword(params)
            .then(res => {
              this.visible = false;
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_success'));
              } else {
                this.visible = false;
                this.formError = res.message;
              }
            })
            .finally(() => {
              this.formLoading = false;
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // error reset
    formInput() {
      this.formError = '';
    },

    // add form reset
    formReset() {
      this.$refs.formElement.resetFields();
      Object.keys(this.form).forEach(key => {
        this.form[key] = undefined;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;
  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}

::v-deep .ant-form-item {
  margin-bottom: 10px;
}
</style>
